import React from 'react';
import { Route } from 'react-router-dom';
import { Admin, CustomRoutes } from 'react-admin';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import defaultMessages from 'i18n/de';
import Login from 'views/login';
import theme from 'theme';

const i18nProvider = polyglotI18nProvider(langCode => {
  if (langCode && langCode !== 'de') {
      return import(`i18n/${langCode}`).then(messages => messages.default);
  }
  return defaultMessages;
}, 'de');

function App() {
  return (
    <Admin
      i18nProvider={i18nProvider}
      dashboard={React.Fragment}
      loginPage={Login}
      theme={theme}
    >
      <CustomRoutes noLayout>
        <Route path='/' element={<Login />} />
      </CustomRoutes>
    </Admin>
  );
}

export default App;
